<div class="mensaje_finalizado_container">
  <p>El elemento no existe</p>
  <mat-icon>error</mat-icon>
</div>
